/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoAnalyticsModelsAvailabilityAppListItem,
    MelcoAnalyticsModelsAvailabilityAppListItemFromJSON,
    MelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped,
    MelcoAnalyticsModelsAvailabilityAppListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
 */
export interface MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem {
    /**
     * 
     * @type {Array<MelcoAnalyticsModelsAvailabilityAppListItem>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
     */
    list: Array<MelcoAnalyticsModelsAvailabilityAppListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSON(json: any): MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem {
    return MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoAnalyticsModelsAvailabilityAppListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemToJSON(value?: MelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoAnalyticsModelsAvailabilityAppListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


